import Show from '../show'

const CardholderDashboard = () => {
  return (
    <Show
      title="Cardholder Dashboard"
      dashboardKey="ch_dashboards"
      showYear={true}
      showAnalytics={true}
    />
  )
}

export default CardholderDashboard
